import { getCountryFlag } from '@/pages/home/_config/countries';
/*
 * @Author: zenghao
 * @Date: 2022-03-09 17:53:12
 * @LastEditors: zenghao
 * @LastEditTime: 2022-04-26 14:41:58
 * @Description: 请填写简介
 */
// 获取指定元素滚动的距离
export const getScrollOffset = (element: any = window) => {
  if (element.pageXOffset) {
    return {
      x: element.pageXOffset,
      y: element.pageYOffset,
    };
  } else {
    return {
      x: element.scrollLeft,
      y: element.scrollTop,
    };
  }
};

// 获取元素坐标
export const getPosition = (element: HTMLElement, container: HTMLElement) => {
  const { y: scrollTop } = getScrollOffset(container);
  if (!element)
    return {
      left: 0,
      top: 0,
    };

  let actualLeft = element.offsetLeft;
  let actualTop = element.offsetTop;
  let current: any = element.offsetParent; // 取得元素的offsetParent
  // 一直循环直到根元素
  while (current !== null) {
    actualLeft += current.offsetLeft;
    actualTop += current.offsetTop;
    current = current.offsetParent;
  }
  // 返回包含left、top坐标的对象
  return {
    left: actualLeft,
    top: actualTop + element.clientHeight + 8 - scrollTop, // 8 为下拉框到结果组件的空隙高度
  };
};

export const importImg = (country: string) => {
  const flagMap: any = {
    'hk': 'cn',
    'mo': 'cn',
    'tw': 'cn',
  }
  country = flagMap[country] ?? country

  let url = ''
  try {
    url = getCountryFlag(country)
    return url
  } catch (err) {
    url = getCountryFlag('default')
    return url
  }
}